<div class="modal fade modal--alert" id="restore-policy-alert-modal" tabindex="-1" role="dialog"
  aria-labelledby="restore-modal"
  aria-modal="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img [src]="'assets/' + policy?.category_id + '/avatar/happy.png'" class="img-fluid" alt="">
          </div>
          <button class="modal-alert__close" (click)="closeRestorePolicyAlertModal()">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h4>From when would you like to restore
            your {{entity == entities.Policy ? policy?.product_name : item?.description_2}} cover?</h4>
          </div>
          <div class="form-group mt-30 mb-0">
            <label class="custom-input custom-input--radio custom-input--pill">
              <input
                type="radio"
                name="cancel-date-cover[]"
                [checked]="restoreDateSelection === restoreDateSelectionEnum.FromDateOfCancellation"
                [value]="restoreDateSelectionEnum.FromDateOfCancellation"
                [(ngModel)]="restoreDateSelection"
                (ngModelChange)="onDateSelectionChange()">
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">From date of cancellation</span>
              </label>
              <label class="custom-input custom-input--radio custom-input--pill">
                <input
                  type="radio"
                  name="cancel-date-cover[]"
                  [checked]="restoreDateSelection === restoreDateSelectionEnum.EndOfMonth"
                  [value]="restoreDateSelectionEnum.EndOfMonth"
                  [(ngModel)]="restoreDateSelection"
                  (ngModelChange)="onDateSelectionChange()">
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">End of this month</span>
                </label>
                <label class="custom-input custom-input--radio custom-input--pill">
                  <input
                    type="radio"
                    name="cancel-date-cover[]"
                    [checked]="restoreDateSelection === restoreDateSelectionEnum.SpecifiedDate"
                    [value]="restoreDateSelectionEnum.SpecifiedDate"
                    [(ngModel)]="restoreDateSelection">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Choose a specific date</span>
                  </label>

                  <div class="mt-15">
                    @if (restoreDateSelection === restoreDateSelectionEnum.SpecifiedDate) {
                      <app-question-date-picker
                        [dateFormat]="'yyyy-MM-dd'"
                        [numberMonths]="1"
                        [minDate]="restoreMinDate"
                        [maxDate]="restoreMaxDate"
                        [initialDate]="restoreInitialDate"
                        [category]="policy?.category_id"
                        (questionAnswer)="onDatePickerChange($event)">
                      </app-question-date-picker>
                    }
                  </div>
                </div>
                <hr class="hr--bdr hr--sm">
                <div class="note note--naked">
                  <div class="note__content">
                    <h6>Important to know</h6>
                    <ul>
                      <li>If your cancellation period exceeds 39 your policy’s premium will be recalculated.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-alert__button">
              <div class="container">
                <a href="javascript:void(0)" class="button button--lg button--secondary" data-dismiss="modal">I'd Rather Not</a>
                <a href="javascript:void(0)"
                  class="button button--lg button--primary"
                  [attr.disabled]="!restoreSelectionDateModalButtonEnabled ? true : null"
                  (click)="populateProperties()">
                  Next
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Summary -->
      <div class="modal fade modal--alert" id="reinstate-summary-modal" tabindex="-1" role="dialog"
        aria-labelledby="reinstate-summary-modal">
        <div class="modal-dialog" role="document">
          <div class="modal-content modal-alert modal-alert--alt">
            <div class="modal-alert__heading">
              <div class="container">
                <div class="modal-alert__avatar">
                  <img [src]="'assets/' + policy?.category_id + '/avatar/happy.png'" class="img-fluid" alt="">
                </div>
                <button class="modal-alert__close" (click)="closeReinstateSummaryModal()">
                  <svg class="icon">
                    <use xlink:href="#close-medium"></use>
                  </svg>
                </button>
              </div>
            </div>
            <div class="modal-alert__content">
              <div class="container">
                <div class="rte">
                  <h4>Ready to restore your cover?</h4>
                </div>
                <ul class="pause-summary mb-30">
                  <li class="pause-summary__item">
                    <div class="pause-summary__label">
                      <p>Your cover will be restored from:</p>
                    </div>
                    <div class="pause-summary__value">
                      <strong>{{restoreDateValue | date: 'd MMM yyyy'}}</strong>
                    </div>
                  </li>
                  <li class="pause-summary__item pause-summary__item--total">
                    <div class="pause-summary__label">
                      @if (refund) {
                        <p>
                          {{refund?.description?.length ? refund?.description[0]?.bill_descr : ''}}
                          <!--<small>({{parseJSON(refund?.description_json)?.bill_dates}})</small>-->
                        </p>
                      }
                    </div>
                    <div class="pause-summary__value">
                      @if (!refund) {
                        <strong>Calculating...</strong>
                      }
                      @if (refund) {
                        <strong
                        >{{accounting?.formatMoney(refund?.description?.length ? refund?.description[0]?.bill_val : 0)}}</strong>
                      }
                    </div>
                  </li>
                </ul>
                <div class="form-group form-group--sm">
                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" id="restore-summary-checkbox" [(ngModel)]="agreeChecked" (ngModelChange)="onAgreeChecked()">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">I confirm that no claims were made on the policy during the cancellation period.</span>
                  </label>
                </div>
                <hr class="hr--bdr hr--sm">
                <div class="note note--naked">
                  <div class="note__content">
                    <h6>Important to know</h6>
                    <ul>
                      <li>By restoring your policy you will keep your cash back bonus and no claim and interrupted cover
                        status.
                      </li>
                      <li>By restoring your policy, you will be fully covered from the day you cancelled.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-alert__button">
              <div class="container">
                <a href="javascript:void(0)"
                  (click)="removeAction(5)"
                  id="restore-summary-no"
                  class="button button--lg button--secondary"
                  data-dismiss="modal">
                No, Keep Cancelled</a>
                <a (click)="changeToActive()"
                  href="javascript:void(0)"
                  class="button button--lg button--primary"
                  [attr.disabled]="!restoreButtonEnabled ? true : null">
                  Yes, Restore Cover
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
